import ReactGA from "react-ga";
import httpService from "./http-service";
import { getHttpConfig } from "./auth-utils";

const traceEvent = (category, action) => {
  ReactGA.event({
    category,
    action
  });
};

const reportError = (action, { err, res }) => {
  try {
    const timeStamp = new Date().getTime().toString();
    let temp = "";
    if (err !== undefined && err.message !== undefined) {
      temp = `${timeStamp} message: ${err.message}`;
    } else if (res !== undefined) {
      temp = `${timeStamp} response: ${JSON.stringify(res, null, 4)}`;
    } else {
      temp = `${timeStamp}  error: ${err.toString()}`;
    }

    traceEvent(`error ${action}`, timeStamp);

    httpService
      .post("/v2/customers/feedback", { feedback: temp }, getHttpConfig())
      .then(() => {})
      .catch(err => {});
  } catch (e) {}
};

export { traceEvent, reportError };
